import React, { useState, useEffect } from 'react';

import Sortable from 'react-sortablejs';
import TooltipPopoverWrapper from 'reactstrap/lib/TooltipPopoverWrapper';
import Dropzone from 'components/pure/form-builder/Dragzone';

class CustomSortable extends Sortable {
  ref = this.props.forwardedRef || React.createRef()
  get node() { return this.ref.current }

  componentDidMount() {
    super.componentDidMount()

    const { sortable } = this
    const { options } = sortable
    const animate = sortable._animate

    sortable._animate = (prevRect, target) => {
      const isGhost = target.classList.contains(options.chosenClass)

      if (isGhost) {
        clearTimeout(target.ghostAnimation)
      }

      animate(prevRect, target)

      if (isGhost) {
        target.ghostAnimation = target.animated
        target.animated = false
      }
    }

    Object.defineProperty(options, 'dragoverBubble', {
      get: () => {
        const { active } = sortable.constructor
        return !!active && active !== sortable && !options.group.checkPut(sortable, active)
      },
    })
  }

  render() {
    const { tag, options, onChange, forwardedRef, ...props } = this.props;
    return <div {...props} ref={this.ref} />
  }
}

export class HoverWrapper extends TooltipPopoverWrapper {
  render() {
    if (!this.props.isOpen)
      return null;

    return this.props.children
  }
}
HoverWrapper.propTypes = { ...TooltipPopoverWrapper.propTypes }

function SortableStore() {
  const moving = {
    from: null,
    to: null
  }

  const setMoving = (from, to) => {
    moving.from = from
    moving.to = to
  }

  return (Component) => (props) => {
    const handleMove = ({ to, from }) => {
      setMoving(from, to)
      props.onChange()
    }
    return <Component {...props} onMove={handleMove} moving={moving} />
  }
}

class SortableContainer extends React.Component {
  ref = React.createRef()

  handleChangeSortable = (data, onDelete, onAdd) => (_order, _, evt) => {
    let { newIndex, oldIndex } = evt

    if (evt.type === 'add') {
      const removeField = evt.from === this.ref.current
      if (removeField) {
        evt.moved = onDelete(evt.oldIndex)
        return
      }
      onAdd(evt)
      return
    }

    if (evt.type === 'update') {
      if (data.length === newIndex) {
        newIndex -= 1
      }

      const [moved] = data.splice(oldIndex, 1)
      data.splice(newIndex, 0, moved)
      this.props.onChange()
    }
  }

  render() {
    const { className, options, children, data, onDelete, onAdd, onMove, moving, onChange, ...props } = this.props
    const sortableClass = this.ref.current === moving.to || children.length == 0
    const draggingClass = moving.from ? 'is-dragging' : ''

    return <CustomSortable {...props} forwardedRef={this.ref}
      className={`${className || ''} ${sortableClass ? '' : ''} ${draggingClass}`}
      onChange={this.handleChangeSortable(data, onDelete, onAdd(data))}
      options={{
        group: 'form-layout',
        animation: 300,
        onMove,
        onAdd: () => onMove({ to: null, from: null }),
        ...options
      }}
    >
      {children}
    </CustomSortable>
  }
}

export const sortableStore = SortableStore()

export const SortableDropzone = sortableStore(function ({ moving: { from }, render }) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(!from)
  }, [from])

  // if (!show)
    // return null

  return <Dropzone render={render} />
})

export const SortableComponent = sortableStore(SortableContainer)